<script>
    import {createEventDispatcher} from 'svelte';

    import Modal from "../../UI/Modal.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";
    import Icono from "../../UI/Icono.svelte";
    import InputNumerico from "../../UI/InputNumerico.svelte";
    import Boton from "../../UI/Boton.svelte";

    export let marcaje = null;

    const dispatch = createEventDispatcher();

    let observaciones = '', valido;
    $: valido = observaciones.trim();

    const eliminar = () => dispatch('borrado', {
      ...marcaje,
      observaciones
    });
</script>

<style>
    p {
        text-align: center;
        margin-bottom: 0;
    }

    strong {
        color: var(--acentos);
    }

    textarea {
        width: 100%;
        border: 1px solid var(--verde);
        margin-top: calc(var(--padding-global) / 2);
        height: 6.8em;
        font-size: 1em;
        font-family: inherit;
        padding: calc(var(--padding-global) / 2);
    }
</style>

<Modal on:cancel title="Eliminación de marcaje incorrecto" estrecho>
    <p>Si pulsa aceptar, se registrará el marcaje como incorrecto.</p>
    <p><strong>¿Está seguro?</strong></p>
    <div class="formulario">
        <div class="motivo">
            <Subtitulo icono="bug_report"><label for="motivo">Motivo</label></Subtitulo>
            <textarea placeholder="Por favor, indique el motivo de la incidencia" id="motivo"
                      bind:value={observaciones}></textarea>
        </div>
    </div>

    <div slot="footer">
        <Boton on:click={eliminar} disabled={!valido} tipo="peligro">
            <Icono margen tamano={16}>check</Icono>
            Aceptar
        </Boton>

        <Boton on:click={() => dispatch('cancel')} tipo="neutral">
            <Icono margen tamano={16}>close</Icono>
            Cancelar
        </Boton>
    </div>
</Modal>